import(/* webpackMode: "eager" */ "/home/deploy/apps/front/src/app/werkstatt-service/page.tsx");
